import { Link } from 'react-router-dom';
import { FolderGit2, User, LogOut } from 'lucide-react';
import { SearchBar } from '../Common';

interface HeaderProps {
  onSearch?: (query: string) => void;
  onLogout?: () => void;
}

export function Header({ onSearch, onLogout }: HeaderProps) {
  return (
    <header className="h-16 bg-white border-b flex items-center justify-between px-6">
      <Link to="/" className="flex items-center gap-3">
        <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
          <FolderGit2 className="w-5 h-5 text-white" />
        </div>
        <span className="text-xl font-semibold text-gray-900">
          Workspace Studio
        </span>
      </Link>

      <div className="flex-1 max-w-xl mx-8">
        {onSearch && (
          <SearchBar
            placeholder="Search files, workspaces..."
            onSearch={onSearch}
          />
        )}
      </div>

      <div className="flex items-center gap-4">
        <button className="p-2 text-gray-500 hover:text-gray-700 rounded-lg hover:bg-gray-100">
          <User className="w-5 h-5" />
        </button>
        {onLogout && (
          <button
            onClick={onLogout}
            className="p-2 text-gray-500 hover:text-gray-700 rounded-lg hover:bg-gray-100"
            title="Logout"
          >
            <LogOut className="w-5 h-5" />
          </button>
        )}
      </div>
    </header>
  );
}
